const aiThree = [
  {
    "name": "有道云笔记",
    "url": "http://note.youdao.com/",
    "icon": "https://note.youdao.com/_nuxt/img/ynote-logo.d8ea7de.png",
    "description": "网易推出的跨平台笔记管理工具，支持文本、图片、语音、Markdown 等多格式内容记录，具备团队协作、文件同步、标签分类等功能，适用于个人知识管理、学习笔记整理及团队文档协作场景。"
  },
  {
    "name": "DeepL",
    "url": "https://www.deepl.com/translator",
    "icon": "https://www.deepl.com/img/logo/deepl-logo-blue.svg",
    "description": "全球领先的AI翻译工具，主打精准的多语言翻译，支持英、德、法、中、日等语言互译，尤其擅长复杂句子和专业术语处理，适用于学术论文翻译、商务文档本地化、跨境沟通等对翻译质量要求高的场景。"
  },
  {
    "name": "FlowUs",
    "url": "https://flowus.cn",
    "icon": "https://cdn2.flowus.cn/assets/_next/static/media/home-logo.78d948f2.png",
    "description": "新一代智能协作文档平台，整合笔记、知识库、项目管理功能，支持多维表格、文件嵌入、团队协作编辑，适合远程团队协作、个人数字资产管理及结构化内容创作场景。"
  },
  {
    "name": "剪映",
    "url": "https://lv.ulikecam.com",
    "icon": "images/jianying.jpg",
    "description": "字节跳动旗下的短视频剪辑工具，提供智能字幕生成、特效素材库、一键成片等功能，支持手机与PC端协同编辑，主要用于抖音、快手等平台的短视频制作，降低视频创作门槛。"
  },
  {
    "name": "Nijijourney",
    "url": "https://nijijourney.com/zh/getting-started/",
    "icon": "images/niji-journey.png",
    "description": "基于AI的图像生成工具，支持用户通过文字描述生成二次元风格插画、角色设计图等，适用于游戏原画设计、动漫创作、社交媒体配图等场景，提供多样化的艺术风格选择。"
  },
  {
    "name": "Compose AI",
    "url": "https://www.compose.ai",
    "icon": "images/compose.png",
    "description": "专注于邮件和文案生成的AI工具，支持根据用户输入的关键词自动生成专业邮件、营销文案、社交媒体帖子等，提升内容创作效率，适用于商务沟通、数字营销等场景。"
  },
  {
    "name": "Grammarly",
    "url": "https://www.grammarlycn.com",
    "icon": "images/grammarly.jpg",
    "description": "全球流行的语法检查和写作辅助工具，支持拼写纠错、语法优化、风格调整（如正式/口语化），并提供词汇替换建议，适用于学术写作、商务邮件、社交媒体内容等场景，提升文本质量。"
  },
  {
    "name": "通义千问",
    "url": "https://tongyi.aliyun.com/",
    "icon": "images/tongyi-logo.png",
    "description": "阿里云推出的通用型AI大模型，支持多模态交互（文本、图像、语音），具备智能问答、内容生成（如故事、代码）、数据分析等能力，适用于企业级智能客服、智能办公、行业解决方案等场景。"
  },
  {
    "name": "Texta",
    "url": "https://texta.ai/",
    "icon": "images/texta.png",
    "description": "AI驱动的内容生成平台，提供博客文章、广告文案、产品描述等多种模板，支持多语言生成和SEO优化，主要服务于电商、营销团队及内容创作者，快速产出高质量文本内容。"
  },
  {
    "name": "Writeseed",
    "url": "https://chromewebstore.google.com/detail/writeseed-ai-writer/cpgmjmiadfoopcjpjinpdjadmljnlnej",
    "icon": "images/writeseed.jpg",
    "description": "Chrome浏览器插件形式的AI写作助手，支持在网页中快速生成邮件、论文段落、社交媒体内容等，提供实时语法检查和创意灵感建议，适合需要高频文字输入的办公场景。",
    "isVpn": true
  },
  {
    "name": "Elephas",
    "url": "https://elephas.app/",
    "icon": "images/elephas.png",
    "description": "推测为AI驱动的内容创作工具，可能支持长文本生成、故事续写或行业报告撰写，适用于作家、自媒体创作者及企业内容团队的高效写作需求。",
    "isVpn": true
  },
  {
    "name": "Everylead",
    "url": "https://www.everylead.ai/",
    "icon": "images/everylead.png",
    "description": "推测为AI销售线索挖掘工具，可能通过数据分析和自然语言处理筛选潜在客户信息，适用于企业市场部门的客户开发和精准营销场景。",
    "isVpn": true
  },
  {
    "name": "Automata",
    "url": "https://byautomata.io/",
    "icon": "images/automata.png",
    "description": "推测为自动化流程工具，可能支持AI驱动的工作流设计、数据处理自动化，适用于企业运营管理、重复性任务优化等场景，提升工作效率。",
    "isVpn": true
  },
  {
    "name": "Gramara",
    "url": "https://gramara.com/en",
    "icon": "images/gramara.jpg",
    "description": "推测为语法和写作风格检查工具，可能专注于特定语言（如西班牙语、葡萄牙语）的文本纠错，适用于多语言内容创作和本地化翻译场景。"
  },
  {
    "name": "Coda AI",
    "url": "https://coda.io/product/ai",
    "icon": "images/coda.png",
    "description": "推测为文档协作与AI助手结合的工具，可能支持在表格和文档中嵌入智能分析、数据可视化功能，适用于团队项目管理和数据驱动的决策场景。"
  },
  {
    "name": "Type",
    "url": "https://type.ai/",
    "icon": "images/type.jpg",
    "description": "推测为AI代码生成或文本输入辅助工具，可能支持智能代码补全、自然语言转代码功能，适用于开发者快速编写程序或普通用户高效输入文本场景。",
    "isVpn": true
  },
  {
    "name": "GoCharlie",
    "url": "https://gocharlie.ai/",
    "icon": "images/gocharlie.jpg",
    "isVpn": true,
    "description": "推测为AI客服或聊天机器人工具，可能支持多轮对话、意图识别，适用于企业客户服务、在线咨询及智能问答场景，提供24小时即时响应。"
  },
  {
    "name": "HyperWrite",
    "url": "https://www.hyperwriteai.com/",
    "icon": "images/hyperwrite.jpg",
    "description": "推测为AI写作增强工具，可能支持文本润色、创意扩展、多语言翻译，适用于学术论文、商业报告及自媒体内容的优化和跨语言传播。"
  },
  {
    "name": "Hoppy Copy",
    "url": "https://www.hoppycopy.co/",
    "icon": "images/Hoppy-Copy.png",
    "description": "推测为AI营销文案生成工具，可能提供广告标题、产品描述、社交媒体帖子等模板，帮助电商和营销人员快速产出吸引眼球的文案内容。"
  },
  {
    "name": "Writers Brew",
    "url": "https://writersbrew.app/",
    "icon": "images/Writers-Brew.png",
    "description": "推测为AI驱动的创意写作平台，可能支持故事创作、诗歌生成、剧本编写，适用于作家、编剧及创意工作者的灵感激发和内容产出。"
  },
  {
    "name": "Jenni",
    "url": "https://jenni.ai/",
    "icon": "images/jenni.png",
    "description": "推测为AI文档协作助手，可能支持智能摘要生成、会议纪要整理、知识图谱构建，适用于企业团队的高效文档处理和知识管理场景。"
  },
  {
    "name": "Easy Peasy",
    "url": "https://easy-peasy.ai/zh",
    "icon": "images/easy-peasy.png",
    "description": "推测为轻量化AI工具，可能提供简单的文本生成、日程管理、信息查询等功能，适合普通用户日常使用，降低AI工具使用门槛。"
  },
  {
    "name": "Moonbeam",
    "url": "https://www.gomoonbeam.com/",
    "icon": "images/moonbeam.png",
    "description": "推测为AI图像或视频处理工具，可能支持智能调色、特效添加、多模态内容生成，适用于数字艺术创作、短视频编辑等创意场景。"
  },
  {
    "name": "Rytr",
    "url": "https://rytr.me/",
    "icon": "images/rytr.png",
    "description": "推测为AI文案生成工具，可能提供多种写作风格（如说服性、幽默性），支持博客、广告、社交媒体等场景的内容快速生成，提升写作效率。"
  },
  {
    "name": "Writerly",
    "url": "https://writerly.ai/",
    "icon": "images/writerly.jpg",
    "description": "推测为专业写作辅助工具，可能支持学术论文结构优化、文献引用自动生成、语法深度检查，适用于科研人员和学生的学术写作场景。"
  },
  {
    "name": "Frase",
    "url": "https://www.frase.io/",
    "icon": "images/frase.png",
    "description": "推测为AI内容优化工具，可能结合SEO分析生成关键词丰富的文本，适用于网站内容创作、博客优化及搜索引擎排名提升场景。"
  },
  {
    "name": "Quillbot",
    "url": "https://quillbot.com/",
    "icon": "images/quillbot.jpg",
    "description": "推测为AI文本改写和优化工具，支持同义替换、句式转换、篇幅调整，适用于学术论文降重、内容改写及多语言翻译后的文本润色场景。"
  },
  {
    "name": "Sudowrite",
    "url": "https://www.sudowrite.com/",
    "icon": "images/sudowrite.jpg",
    "description": "推测为AI故事生成工具，可能支持用户输入剧情大纲后自动生成详细故事内容，适用于小说创作、剧本编写及创意写作教学场景。"
  },
  {
    "name": "Writer",
    "url": "https://writer.com/",
    "icon": "images/writer.png",
    "description": "推测为通用型AI写作助手，可能支持多种文本类型（如邮件、报告、简历）生成，提供智能纠错和风格调整，适用于日常办公和个人写作需求。"
  },
  {
    "name": "Supernormal",
    "url": "https://supernormal.com/",
    "icon": "images/supernormal.jpg",
    "description": "推测为AI视频生成工具，可能支持文本转视频、智能剪辑、语音合成，适用于企业宣传视频、教育视频及短视频快速制作场景。"
  },
  {
    "name": "SEO AI",
    "url": "https://www.seo.ai/",
    "icon": "images/seo.png",
    "description": "推测为AI驱动的搜索引擎优化工具，可能提供关键词分析、内容SEO评分、竞争对手分析，适用于网站运营和数字营销团队的SEO策略制定。"
  },
  {
    "name": "Writesonic",
    "url": "https://writesonic.com/",
    "icon": "images/writesonic.png",
    "description": "推测为AI内容生成平台，可能支持电商产品描述、博客文章、广告文案生成，提供多语言支持和模板化创作，提升内容产出效率。"
  },
  {
    "name": "Copy.Al",
    "url": "https://www.copy.ai/",
    "icon": "images/copy.png",
    "description": "推测为AI营销文案工具，可能专注于社交媒体广告、电商落地页文案生成，结合用户画像和产品卖点生成高转化率内容。"
  },
  {
    "name": "Boo.ai",
    "url": "https://boo.ai/",
    "icon": "images/boo.jpg",
    "description": "推测为AI聊天机器人或创意工具，可能支持趣味对话、角色扮演、故事接龙，适用于娱乐社交和年轻化内容创作场景。"
  },
  {
    "name": "Orchard",
    "url": "https://orchard.ai/",
    "icon": "images/orchard.png",
    "description": "推测为AI知识管理工具，可能支持文档分类、信息检索、知识图谱构建，适用于企业和个人的海量数据整理与智能搜索场景。"
  },
  {
    "name": "Notion AI",
    "url": "https://www.notion.so/product/ai",
    "icon": "images/notion.png",
    "description": "Notion集成的AI助手，支持在笔记中生成文本、总结内容、创建任务列表等，适用于Notion用户的智能办公和高效内容创作场景。"
  },
  {
    "name": "stockimg",
    "url": "https://stockimg.ai/",
    "icon": "images/stockimg.jpg",
    "description": "推测为AI图像素材平台，可能提供版权图片搜索、智能图片生成（如产品配图、插画），适用于设计师、电商运营和自媒体的视觉内容创作场景。"
  },
  {
    "name": "Phygital+",
    "url": "https://phygital.plus/",
    "icon": "images/phygitalplus.jpg",
    "description": "推测为AI驱动的虚实融合工具，可能支持AR/VR内容生成、数字孪生模型构建，适用于零售、教育、房地产等行业的沉浸式体验设计场景。"
  },
  {
    "name": "Riffusion",
    "url": "https://www.riffusion.com/",
    "icon": "images/riffusion.png",
    "description": "推测为AI音乐生成工具，可能支持根据用户输入的风格（如古典、电子）自动生成音乐片段，适用于视频配乐、游戏音效及音乐创作爱好者场景。"
  },
  {
    "name": "Palette.fm",
    "url": "https://palette.fm/",
    "icon": "images/palettefm.png",
    "description": "推测为AI图像调色工具，可能支持智能色彩匹配、风格迁移、图片滤镜生成，适用于摄影师、设计师的图像后期处理和视觉效果优化场景。"
  },
  {
    "name": "文心一言",
    "url": "https://yiyan.baidu.com",
    "icon": "images/wxyy.png",
    "description": "百度推出的中文通用AI大模型，支持多轮对话、内容创作（如故事、诗歌、代码）、知识问答、图像生成等，针对中文语境优化，适用于智能客服、教育辅导、内容创作等场景。"
  },
  {
    "name": "Readwise",
    "url": "https://readwise.io/",
    "icon": "images/readwise.png",
    "description": "推测为AI阅读辅助工具，可能支持书籍/文章摘要生成、知识点提取、阅读笔记整理，适用于高效学习、文献阅读及知识沉淀场景。"
  },
  {
    "name": "秘塔写作猫",
    "url": "https://xiezuocat.com/",
    "icon": "images/mitaxiezuomao.jpg",
    "description": "推测为中文写作辅助工具，可能提供语法检查、错别字纠正、文风优化等功能，支持网页和文档插件，适用于中文用户的日常写作和办公场景。"
  },
  {
    "name": "Wordtune",
    "url": "https://www.wordtune.com/",
    "icon": "images/wordtune.png",
    "description": "推测为AI文本优化工具，可能支持调整文本语气（如正式转口语）、篇幅精简、多语言翻译，适用于邮件沟通、社交媒体内容的个性化表达场景。"
  },
  {
    "name": "copysmith",
    "url": "https://copysmith.ai/",
    "icon": "images/copysmith.jpg",
    "description": "推测为AI电商文案生成工具，可能专注于产品描述、广告标题、促销文案生成，结合电商平台特性提升转化率，适用于跨境电商和独立站运营场景。"
  },
  {
    "name": "通义听悟",
    "url": "https://tingwu.aliyun.com/",
    "icon": "images/tongyi-tingwu.jpg",
    "description": "推测为AI语音识别与会议记录工具，可能支持实时语音转文字、会议纪要生成、重点标注，适用于远程会议、讲座培训的信息整理场景。"
  },
  {
    "name": "彩云小梦",
    "url": "https://if.caiyunai.com/dream/",
    "icon": "images/caiyunxiaomeng.png",
    "description": "推测为AI故事创作工具，可能支持用户输入开头后自动生成续写内容，提供多种故事风格，适用于小说爱好者和创意写作入门者场景。"
  },
  {
    "name": "万彩AI",
    "url": "https://www.animiz.cn/ai/",
    "icon": "images/wancai.png",
    "description": "推测为AI视频或动画生成工具，可能支持智能生成企业宣传视频、动画短片，提供模板化操作，降低视频制作技术门槛。"
  },
  {
    "name": "火山写作",
    "url": "https://www.writingo.net/",
    "icon": "images/huoshan-xiezuo.png",
    "description": "推测为字节跳动旗下的AI写作工具，可能支持多体裁内容生成（如新闻、小说、营销文案），结合推荐算法优化内容传播效果，适用于自媒体和内容平台创作者。"
  },
  {
    "name": "悉语",
    "url": "https://www.xfyun.cn/solution/xy",
    "icon": "images/xiyu.jpg",
    "description": "推测为AI智能客服系统，可能支持多渠道接入、意图识别、自动回复，适用于电商、教育等行业的客户服务场景，提升响应效率。"
  },
  {
    "name": "Vega AI",
    "url": "https://www.vegaai.net/",
    "icon": "images/vega.jpg",
    "description": "推测为AI数据分析工具，可能支持数据可视化、趋势预测、异常检测，适用于企业决策支持和业务数据分析场景。"
  },
  {
    "name": "Jasper",
    "url": "https://www.jasper.ai/",
    "icon": "images/jasper.png",
    "description": "全球领先的AI内容生成平台，专注于营销文案、电商产品描述、社交媒体内容创作，支持多语言和多场景模板，帮助企业和个人快速产出高质量的营销内容。"
  },
  {
    "name": "包阅AI",
    "url": "https://www.baoyue.ai/",
    "icon": "images/baoyue.png",
    "description": "推测为AI阅读与知识管理工具，可能支持书籍精读、知识点提炼、阅读计划制定，适用于终身学习者和知识型博主的内容消化场景。"
  },
  {
    "name": "灵办AI",
    "url": "https://lingban.ai/",
    "icon": "images/lingban.jpg",
    "description": "推测为AI办公助手，可能支持智能日程管理、邮件分类、会议安排，适用于企业员工的日常办公效率提升场景。"
  },
  {
    "name": "Liner",
    "url": "https://getliner.com/",
    "icon": "images/liner.png",
    "description": "推测为AI文本标注工具，可能支持网页内容高亮、笔记添加、知识点提取，适用于在线学习、文献研究的信息整理场景。"
  },
  {
    "name": "Course Hero",
    "url": "https://www.coursehero.com/",
    "icon": "images/coursehero.png",
    "description": "推测为AI教育辅助工具，可能提供课程资料搜索、作业答疑、学习资源推荐，适用于学生群体的课后学习和备考场景。"
  },
  {
    "name": "Beacons",
    "url": "https://beacons.ai/",
    "icon": "images/beacons.jpg",
    "description": "推测为AI链接管理工具，可能支持多平台内容聚合、个人主页生成，适用于网红、创作者的社交媒体流量聚合场景。"
  },
  {
    "name": "Gamma AI",
    "url": "https://gamma.app/",
    "icon": "images/gamma.jpg",
    "description": "推测为AI演示文稿生成工具，可能支持文本转PPT、智能排版、图表生成，适用于商务汇报、教学课件的快速制作场景。"
  },
  {
    "name": "MaxAI.me",
    "url": "https://www.maxai.me/",
    "icon": "images/maxai.jpg",
    "description": "推测为多模态AI工具，可能支持文本、图像、语音交互，提供创意生成、实时翻译等功能，适用于跨领域创作和全球化沟通场景。"
  },
  {
    "name": "GPTZero",
    "url": "https://gptzero.me/",
    "icon": "images/gptzero.png",
    "description": "推测为AI内容检测工具，可能用于识别文本是否由GPT等模型生成，适用于学术诚信检测、稿件原创性验证场景。"
  },
  {
    "name": "ChatPDF",
    "url": "https://www.chatpdf.com/",
    "icon": "images/chatpdf.png",
    "description": "推测为AI文档对话工具，可能支持用户通过自然语言提问与PDF文档交互，提取关键信息、生成摘要，适用于学术论文、法律文档的快速理解场景。"
  },
  {
    "name": "Speechify",
    "url": "https://speechify.com/",
    "icon": "images/speechify.jpg",
    "description": "推测为AI语音转换工具，可能支持文本转语音、语音合成，提供多音色选择，适用于有声书制作、视力障碍辅助及移动场景下的信息获取。"
  },
  {
    "name": "SciSpace",
    "url": "https://typeset.io/",
    "icon": "images/scispace.jpg",
    "description": "推测为AI学术辅助工具，可能支持论文查重、文献综述生成、期刊推荐，适用于科研人员和研究生的学术研究场景。"
  },
  {
    "name": "Gauth",
    "url": "https://www.gauthmath.com/",
    "icon": "images/gauth.png",
    "description": "推测为AI数学解题工具，可能支持公式识别、步骤解析、错题讲解，适用于K12教育和数学学习辅导场景。"
  },
  {
    "name": "Casetext",
    "url": "https://casetext.com/",
    "icon": "images/casetext.png",
    "description": "推测为AI法律辅助工具，可能支持案例检索、合同审查、法律文书生成，适用于律师和企业法务部门的高效办公场景。"
  },
  {
    "name": "HIX.AI",
    "url": "https://hix.ai/",
    "icon": "images/hix.png",
    "description": "推测为AI网页设计工具，可能支持智能生成网站原型、UI设计图，提供拖拽式操作，降低网页开发门槛，适用于中小企业和个人开发者场景。"
  },
  {
    "name": "Otter.ai",
    "url": "https://otter.ai/",
    "icon": "images/otter.jpg",
    "description": "推测为AI语音笔记工具，可能支持实时录音转文字、会议记录同步，适用于记者、学生的信息快速记录场景。"
  },
  {
    "name": "Notta",
    "url": "https://www.notta.ai/",
    "icon": "images/notta.png",
    "description": "推测为AI语音识别工具，可能支持多语言语音转文字、实时翻译，适用于跨国会议、外语学习的听力辅助场景。"
  },
  {
    "name": "PopAl",
    "url": "https://popal.ai/",
    "icon": "images/Popal.png",
    "description": "推测为AI流行文化工具，可能支持热点话题分析、流行语生成，适用于社交媒体运营和年轻化内容创作场景。"
  },
  {
    "name": "Glarity",
    "url": "https://glarity.app/",
    "icon": "images/glarity.jpg",
    "description": "推测为AI网页内容增强工具，可能支持智能摘要、广告拦截、信息聚合，适用于高效浏览和知识获取场景。"
  },
  {
    "name": "笔灵AI",
    "url": "https://www.biling.ai/",
    "icon": "images/biling.jpg",
    "description": "推测为中文AI写作助手，可能支持诗词生成、对联创作、文案润色，适用于传统文化爱好者和创意写作场景。"
  },
  {
    "name": "绘蛙",
    "url": "https://www.huiwa.ai/",
    "icon": "images/huiwa.png",
    "description": "推测为AI绘画工具，可能支持用户通过文字描述生成插画、漫画，提供多种绘画风格，适用于艺术创作和设计灵感获取场景。"
  },
  {
    "name": "Vidu",
    "url": "https://www.vidu.io/",
    "icon": "images/vidu.jpg",
    "description": "推测为AI视频剪辑工具，可能支持智能字幕、自动转场、特效添加，适用于短视频创作者的快速剪辑场景。"
  },
  {
    "name": "快问CopyDone",
    "url": "https://www.copydone.cn/",
    "icon": "images/kuaiwencopydone.jpg",
    "description": "推测为AI快速写作工具，可能支持短文案秒级生成，适用于电商平台的商品描述、社交媒体帖子的批量生产场景。"
  },
  {
    "name": "讯飞智检",
    "url": "https://zhiyan.xfyun.cn/",
    "icon": "images/xunfeizhijian.png",
    "description": "推测为AI文本质量检测工具，可能支持语法纠错、逻辑检查、敏感词过滤，适用于新闻媒体、出版行业的内容审核场景。"
  },
  {
    "name": "腾讯Effdit",
    "url": "https://effdit.qq.com/",
    "icon": "images/tencenteffdit.jpg",
    "description": "推测为腾讯推出的AI文档编辑工具，可能支持智能排版、协作编辑、版本控制，适用于企业级文档管理和团队协作场景。"
  },
  {
    "name": "讯飞写作",
    "url": "https://write.xfyun.cn/",
    "icon": "images/xunfeixiezuo.png",
    "description": "推测为科大讯飞的AI写作助手，可能支持语音输入转文字、智能段落生成，适用于办公场景的高效文字录入和内容创作。"
  },
  {
    "name": "字节火山写作",
    "url": "https://writer.volcengine.com/",
    "icon": "images/zijihuoshanxiezuo.png",
    "description": "推测为字节跳动旗下的AI写作平台，可能支持多体裁内容生成，结合推荐算法优化内容传播，适用于头条、抖音等平台的创作者场景。"
  },
  {
    "name": "光速写作",
    "url": "https://www.gsuwrite.com/",
    "icon": "images/guangsuxiezuo.png",
    "description": "推测为AI高速写作工具，可能支持长文本快速生成、内容结构化，适用于报告撰写、小说创作的高效产出场景。"
  },
  {
    "name": "Writewise",
    "url": "https://writewise.io/",
    "icon": "images/writewise.png",
    "description": "推测为AI写作智能工具，可能支持写作风格分析、内容质量评分，适用于专业写作者的自我提升和作品优化场景。"
  },
  {
    "name": "5118 SEO优",
    "url": "https://www.5118.com/seo/",
    "icon": "images/5118seoyou.jpg",
    "description": "推测为SEO优化工具，可能提供关键词挖掘、竞争对手分析、内容SEO建议，适用于网站运营和数字营销的SEO策略制定场景。"
  },
  {
    "name": "Giiso写作机",
    "url": "https://www.giiso.com/",
    "icon": "images/giisoxiezuoji.jpg",
    "description": "推测为AI新闻写作工具，可能支持实时资讯自动生成、数据报告撰写，适用于媒体机构和金融行业的快速内容产出场景。"
  },
  {
    "name": "Paterpal",
    "url": "https://www.paterpal.com/",
    "icon": "images/Paterpal.jpg",
    "description": "推测为AI专利辅助工具，可能支持专利文档撰写、技术方案分析，适用于企业知识产权部门和科研团队的专利申报场景。"
  },
  {
    "name": "新华妙笔",
    "url": "https://miaobi.xinhuaskl.com/?channel=shuzhi",
    "icon": "images/xinhuamiaobi.png",
    "description": "推测为新华社旗下的AI写作工具，可能支持新闻稿件生成、时事热点分析，适用于媒体行业的高效新闻生产场景。"
  },
  {
    "name": "笔灵AI小说",
    "url": "https://ibiling.cn/novel-workbench",
    "icon": "images/bilingaixiaoshuo.png",
    "description": "推测为专注于小说创作的AI工具，可能支持人物设定、剧情推演、章节生成，适用于网络小说作者的灵感辅助和内容创作场景。"
  },
  {
    "name": "讯飞文书",
    "url": "https://gw.iflydocs.com/",
    "icon": "images/xfwenshu.png",
    "description": "推测为AI文书生成工具，可能支持合同、简历、报告等专业文书自动生成，适用于商务办公和个人职业发展场景。"
  },
  {
    "name": "墨狐AI",
    "url": "https://inkfox-ai.com/#/home",
    "icon": "images/mohu.jpg",
    "description": "推测为AI写作与创意工具，可能支持多语言内容生成、跨文化内容适配，适用于全球化内容创作和翻译场景。"
  },
  {
    "name": "稿易",
    "url": "https://gaoyiai.com/",
    "icon": "images/gaoyi.jpg",
    "description": "推测为AI稿件优化工具，可能支持稿件查重、逻辑校对、风格统一，适用于出版、教育行业的内容审核和质量控制场景。"
  },
  {
    "name": "千笔",
    "url": "https://www.aipaperpass.com/?pic=g5DP",
    "icon": "images/qianbi.png",
    "description": "推测为AI写作平台，可能支持海量模板库、智能内容推荐，适用于企业营销、自媒体运营的批量内容生产场景。"
  }
]

export default aiThree
